import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AreaGroupType } from 'src/app/server-api/models';
import { EnumDropdownComponent } from 'src/app/utils-flc/enum-dropdown/enum-dropdown.component';


@Component({
  selector: 'app-area-group-type-dropdown',
  templateUrl: './area-group-type-dropdown.component.html',
  styleUrls: ['./area-group-type-dropdown.component.css']
})
export class AreaGroupTypeDropdownComponent extends EnumDropdownComponent {

  constructor(
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'area-group-type-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.items = [];
    
    this.items = Object.keys(AreaGroupType).map(key => AreaGroupType[key].replace('GROUP_', ''));
            
    this.setPreSelect(this.preSelect);
  }
}
